import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';

import { CampaignsCompletedComponent } from './campaigns-completed/campaigns-completed.component';
import { CreationEditionDialogComponent } from './creation-edition-dialog/creation-edition-dialog.component';
import { MassMessagingDetailsComponent } from './mass-messaging-details/mass-messaging-details.component';
import { MassMessagingComponent } from './mass-messaging.component';

@NgModule({
  declarations: [
    CreationEditionDialogComponent,
    MassMessagingComponent,
    CampaignsCompletedComponent,
    MassMessagingDetailsComponent,
  ],
  imports: [CommonModule, SharedModule],
})
export class MassMessagingModule {}
